import React, { Component } from 'react';
import {toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import {ValidateState} from '../../../functions';
import {API_URL} from '../../../constants';
import {updateValueInJson, validateAccesoGeneral, getRoles, esUrl} from '../../../functions';
import axios from 'axios';
import $ from 'jquery';

export default class AgregarCategoriaExportaFacil extends Component {

    constructor(props) {
        super(props);

        this.state = {
            categoriaLongitud:0,
            resource: {
                cxfa_Nombre:"",
                cxfa_VideoYoutube:"",
                cxfa_Orden: this.props.location.state !== undefined ? this.props.location.state.totalRegistros + 1 : "",
                cxfa_Activo: true
            },
            Validacion: {
                cxfa_Nombre: {
                    Error: false,
                },
                cxfa_VideoYoutube: {
                    Error: false,
                },
                cxfa_Orden: {
                    Error: false,
                }
            },
            hasError:false,
            hasErrorProceso:false,
            added: false,
            security: cookie.load('user'),
            roles: [],
            agrupador:"",
            menuGeneral:[]
          }
        this.handleInputChange = this.handleInputChange.bind(this);

      }

    componentDidMount()
    {
        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        let locationState = this.props.location.state;
        let pathNameList = "/categorias-exporta-facil";

        var roles = getRoles(this.state.security);
        var rol = roles.length > 0 ? roles[0].nRolCodigo : "";

        validateAccesoGeneral(locationState, pathNameList, rol);
    }

    handleClickCancel(e) {
        const {history: {push}} = this.props;
        push('/categorias-exporta-facil');
     }

     callFunctionButton = (event) => {

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.cxfa_Nombre == '') {

            newState.Validacion.cxfa_Nombre = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.cxfa_VideoYoutube == '' || !esUrl(newState.resource.cxfa_VideoYoutube))
		{
            newState.Validacion.cxfa_VideoYoutube = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.cxfa_Orden == '') {
            newState.Validacion.cxfa_Orden = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError)
		{
            this.setState(newState);
            return;
        }

        const url = `${API_URL}CategoriaExportaFacilUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'cxfa_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url,
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {

            if (data.data.isSucess)
            {

                let stateResponse = this.state;

                stateResponse.added = true;
                stateResponse.resource.cxfa_Nombre = '';
                stateResponse.resource.cxfa_Orden += 1 ;
                stateResponse.resource.cxfa_VideoYoutube = '';

                this.setState(stateResponse);

                setTimeout(() => {
                    this.setState({added:false});
                }, 3000);

            } else
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => {
                    this.setState({hasErrorProceso:false});
                }, 3000);
            }
        }
        ).catch((error)=> {
        toast.error('Error no controlado.');
        this.setState({loading:false});
        });
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let longitudCategoria = this.state.categoriaLongitud;

        let validaciones = this.state.Validacion;
        validaciones[target.name] = {
            Error: false,
        }

        if(target.name == 'cxfa_Nombre'){
            longitudCategoria = value.length;
        }
        this.setState({
            resource: copyResource,
            categoriaLongitud: longitudCategoria,
            Validacion: validaciones
        });
    }

    render() {
        return (
            <div class="">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt />
                        <a  href="/">
                            / Panel de configuración general
                        </a >
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Agregar Categoría Exporta Fácil</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Agregar Categoría de Exporta Fácil
                </div>

                {
                    this.state.hasErrorProceso ?
                    <div className="relative">
                        <div className="textAlertaError">
                            <div>Error, no se pudo realizar el registro.</div>
                        </div>
                    </div> : null
                }

                {
                    this.state.added ?
                    <div className="relative">
                        <div className="textAlertaOK">
                            <div>Se realizó el registro correctamente.</div>
                        </div>
                    </div>: null
                }

                <div className="div_Modulos_Noticias">
                    <div className="txtFile x-1">
                        <input type="text" placeholder="Categoría" name='cxfa_Nombre' value={this.state.resource.cxfa_Nombre} maxLength={25} className={this.state.Validacion.cxfa_Nombre.Error ? "error" : ""}
                        onChange={this.handleInputChange}/>
                        <span data-length={25}>{this.state.categoriaLongitud}/25</span>
                    </div>
                    <div className="x-2 relative">
                        <input type="text" placeholder="Enlace Video de Youtube" name='cxfa_VideoYoutube' value={this.state.resource.cxfa_VideoYoutube} id="txtIconoCategoria" className={this.state.Validacion.cxfa_VideoYoutube.Error ? "error" : ""} onChange={this.handleInputChange}/>
                    </div>
                    <div className="txtFile x-2">
                        <input type="text" placeholder="Orden" name='cxfa_Orden' value={this.state.resource.cxfa_Orden} maxLength={2} className={this.state.Validacion.cxfa_Orden.Error ? "error" : ""} onChange={this.handleInputChange} onChange={this.handleInputChange}/>
                    </div>
                    <div className="divContenedorBtn_Noticias">
                        <a href="#"  className="btnActivo"  onClick={(event) => this.callFunctionButton(event)}>GUARDAR </a>
                        <a href="#"  onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <br />
                <br />

            </div>
        )
    }
}
